
function savgolFilter(data, windowSize) {
    // Predefined coefficients for polynomial order of 3
    const coeffs = {
        11: [-0.0839160839160813, 0.02097902097902253, 0.1025641025641035, 0.16083916083916147, 0.19580419580419633, 0.20745920745920798, 0.19580419580419628, 0.16083916083916105, 0.10256410256410223, 0.020979020979019623, -0.08391608391608689],
        21: [-0.055900621118009836, -0.024844720496892753, 0.002942137953580476, 0.027459954233409807, 0.04870872834259528, 0.06668846028113685, 0.08139915004903453, 0.09284079764628829, 0.10101340307289813, 0.10591696632886406, 0.10755148741418605, 0.10591696632886405, 0.1010134030728981, 0.09284079764628818, 0.08139915004903427, 0.06668846028113638, 0.04870872834259448, 0.02745995423340857, 0.0029421379535786336, -0.024844720496895328, -0.05590062111801335],
        31: [-0.041055718475072306, -0.02639296187683226, -0.0127414298715742, -0.00010112245929821614, 0.011527960359995683, 0.0221458185863075, 0.03175245221963724, 0.04034786125998491, 0.04793204570735049, 0.05450500556173401, 0.060066740823135435, 0.06461725149155478, 0.06815653756699205, 0.07068459904944724, 0.07220143593892037, 0.0727070482354114, 0.07220143593892037, 0.07068459904944724, 0.06815653756699205, 0.06461725149155478, 0.06006674082313543, 0.054505005561734, 0.04793204570735049, 0.04034786125998491, 0.031752452219637246, 0.022145818586307507, 0.011527960359995685, -0.00010112245929821961, -0.012741429871574186, -0.02639296187683223, -0.04105571847507236]
    };

    if (!coeffs[windowSize]) {
        throw new Error('Coefficients for the specified window size are not defined, try 11, 21 or 31');
    }

    const coefficients = coeffs[windowSize];
    let filtered = [];
    const halfWindow = Math.floor(windowSize / 2);

    for (let i = 0; i < data.length; i++) {
        let sum = 0;
        for (let j = -halfWindow, k = 0; j <= halfWindow; j++, k++) {
            let index = i + j;
            if (index < 0) {
                index = 0;
            } else if (index >= data.length) {
                index = data.length - 1;
            }
            sum += data[index] * coefficients[k];
        }
        filtered.push(sum); // These coefficients do not require division for normalization
    }

    return filtered;
}

function findCustomPeaks(data, distance = 10) {
    let peaks = [];
    data = savgolFilter(data, 11); // Apply Savitzky-Golay filter

    let dataMean = data.reduce((a, b) => a + b, 0) / data.length;
    let filteredArray = data.filter(x => x > dataMean / 2);
    dataMean = filteredArray.reduce((a, b) => a + b, 0) / filteredArray.length;

    let lastPeak = null;
    let flatSize = 0;
    for (let i = Math.round(distance / 2); i < data.length - Math.round(distance / 2); i++) {
        flatSize += data[i] < dataMean ? 1 : 0;
        if (data[i] > data[i - 1] && data[i] > data[i + 1] && data[i] > dataMean) {
            let leftMax = Math.max(...data.slice(i - Math.round(distance / 2), i));
            let rightMax = Math.max(...data.slice(i + 1, i + Math.round(distance / 2) + 1));
            if (leftMax < data[i] && rightMax < data[i]) {
                if (lastPeak === null || flatSize > distance) {
                    peaks.push(i);
                    lastPeak = i;
                    flatSize = 0;
                }
            }
        }
    }

    return peaks;
}

function scaledChange(array, windowSize = 5) {
    let scaledChanges = new Array(array.length).fill(0);
    for (let i = 0; i < array.length - windowSize; i++) {
        let windowValues = array.slice(i, i + windowSize);
        let maxChange = array[i] - Math.min(...windowValues);
        scaledChanges[i] = maxChange;
    }
    return scaledChanges;
}

function detectLineEnds(dataObjects) {
    let xValues = dataObjects.map(obj => obj.x);
    let timestamps = dataObjects.map(obj => obj.TS);

    let smoothed = savgolFilter(xValues, 21);
    let delicateSmoothed = savgolFilter(xValues, 11);

    let changes = scaledChange(smoothed);
    let peaks = findCustomPeaks(changes, 10);

    let endOfFalls = [];
    let startOfFalls = [];
    for (let peak of peaks) {
        let startWindow = delicateSmoothed.slice(Math.max(peak - 5, 0), peak);
        let startOfFall = startWindow.indexOf(Math.max(...startWindow)) + peak - 5;

        let endWindow = delicateSmoothed.slice(peak, peak + 15);
        let endOfFall = endWindow.indexOf(Math.min(...endWindow)) + peak;

        endOfFalls.push(endOfFall);
        startOfFalls.push(startOfFall);
    }

    // Calculate time intervals
    let intervals = [0];
    for (let i = 1; i < endOfFalls.length; i++) {
        intervals.push(timestamps[endOfFalls[i]] - timestamps[endOfFalls[i - 1]]);
    }

    return {
        endOfLineLocations: endOfFalls,
        timeIntervals: intervals
    };

}




function calculateMedian(arr) {
    // Step 1: Sort the array in ascending order
    const sortedArr = arr.slice().sort((a, b) => a - b);

    const n = sortedArr.length;

    // Step 2: Calculate median for odd number of elements
    if (n % 2 !== 0) {
        return sortedArr[Math.floor(n / 2)];
    } else {
        // Step 3: Calculate median for even number of elements
        const middle1 = sortedArr[n / 2 - 1];
        const middle2 = sortedArr[n / 2];
        return (middle1 + middle2) / 2;
    }
}

function stats(arr) {
    // If the array is empty, return null values
    if (arr.length === 0) {
        return {
            mean: null,
            std: null
        };
    }

    // Calculate mean (average)
    let sum = arr.reduce((acc, val) => acc + val, 0);
    let mean = sum / arr.length;

    // Calculate standard deviation
    let variance = arr.reduce((acc, val) => acc + Math.pow(val - mean, 2), 0) / arr.length;
    let std = Math.sqrt(variance);

    return {
        mean: parseInt(mean),
        std: Number(std.toFixed(1))
    };
}

export function calcWPM(combinedIrisPosXMove, linesData) {
    //first calculate the lines ends and intervals per pick
    const result = detectLineEnds(combinedIrisPosXMove);
    console.log("🚀 ~ calcWPM ~ result:", result)
    let timeIntervals = result.timeIntervals;
    //remove first cell in every array
    timeIntervals.shift()
    let linesDataMinusFirstLine = linesData.slice(1);
    console.log("🚀 ~ calcWPM ~ linesDataMinusFirstLine:", linesDataMinusFirstLine)
    //find median חציון
    let wordReadingAvgPerLine = timeIntervals.map((timeInterval, i, arr) => {
        console.log("linesDataMinusFirstLine[i==]" + i, linesDataMinusFirstLine[i])
        return linesDataMinusFirstLine[i]?.words ? ((linesDataMinusFirstLine[i].words / timeInterval)) * 60000 : 0//plaster? 
    });
    if (wordReadingAvgPerLine[wordReadingAvgPerLine.length - 1] == 0) {
        wordReadingAvgPerLine.pop();
    };
    // let wordReadingAvgPerLine = timeIntervals.map((timeInterval, i, arr) => ((linesDataMinusFirstLine[i].words / timeInterval)) * 60000);
    let median = calculateMedian(wordReadingAvgPerLine)

    //clear those are too far from median
    let wordInMedianRange = wordReadingAvgPerLine.map((value, i) => {
        if (value > median * 1.5 || value < median * 0.5) {
            return false
        } else {
            return value
        }
    })
    let finallArr = wordInMedianRange.filter(Boolean)

    //remove last cell bacause it is the last line 
    finallArr.pop()
    //calc total AVG and STD
    let AvgNStd = stats(finallArr)

    return AvgNStd
}


let combinedIrisPosXMove = [
    {
        "TS": 1710775753763,
        "x": -0.052916862
    },
    {
        "TS": 1710775753830,
        "x": -0.052251678
    },
    {
        "TS": 1710775753900,
        "x": -0.050539616
    },
    {
        "x": -0.04879463,
        "TS": 1710775753981
    },
    {
        "TS": 1710775754046,
        "x": -0.04687063
    },
    {
        "TS": 1710775754109,
        "x": -0.040128116
    },
    {
        "TS": 1710775754183,
        "x": -0.03948067
    },
    {
        "x": -0.048112057,
        "TS": 1710775754266
    },
    {
        "TS": 1710775754349,
        "x": -0.060120527
    },
    {
        "TS": 1710775754473,
        "x": -0.076390155
    },
    {
        "x": -0.088416174,
        "TS": 1710775754596
    },
    {
        "x": -0.09136243,
        "TS": 1710775754688
    },
    {
        "x": -0.083762124,
        "TS": 1710775754760
    },
    {
        "x": -0.07213495,
        "TS": 1710775754855
    },
    {
        "x": -0.060200278,
        "TS": 1710775754965
    },
    {
        "x": -0.054060612,
        "TS": 1710775755090
    },
    {
        "TS": 1710775755189,
        "x": -0.03581231
    },
    {
        "x": -0.018771231,
        "TS": 1710775755252
    },
    {
        "TS": 1710775755309,
        "x": -0.012851864
    },
    {
        "TS": 1710775755376,
        "x": -0.0033983923
    },
    {
        "TS": 1710775755447,
        "x": 0.021549746
    },
    {
        "x": 0.030424336,
        "TS": 1710775755523
    },
    {
        "x": 0.029837092,
        "TS": 1710775755588
    },
    {
        "x": 0.030720634,
        "TS": 1710775755647
    },
    {
        "x": 0.024885232,
        "TS": 1710775755726
    },
    {
        "TS": 1710775755783,
        "x": 0.024494886
    },
    {
        "x": 0.027451903,
        "TS": 1710775755855
    },
    {
        "x": 0.03617837,
        "TS": 1710775755940
    },
    {
        "x": 0.03751494,
        "TS": 1710775756004
    },
    {
        "TS": 1710775756064,
        "x": 0.034812763
    },
    {
        "TS": 1710775756135,
        "x": 0.031103391
    },
    {
        "TS": 1710775756194,
        "x": 0.027207341
    },
    {
        "x": 0.02751749,
        "TS": 1710775756246
    },
    {
        "x": 0.029348683,
        "TS": 1710775756293
    },
    {
        "TS": 1710775756346,
        "x": 0.031040844
    },
    {
        "x": -0.041830923,
        "TS": 1710775756403
    },
    {
        "x": -0.072681114,
        "TS": 1710775756453
    },
    {
        "TS": 1710775756526,
        "x": -0.09093383
    },
    {
        "x": -0.09944121,
        "TS": 1710775756603
    },
    {
        "TS": 1710775756665,
        "x": -0.10777901
    },
    {
        "TS": 1710775756741,
        "x": -0.11451299
    },
    {
        "TS": 1710775756807,
        "x": -0.12011109
    },
    {
        "TS": 1710775756910,
        "x": -0.109302044
    },
    {
        "TS": 1710775756975,
        "x": -0.0990992
    },
    {
        "x": -0.085821696,
        "TS": 1710775757028
    },
    {
        "TS": 1710775757080,
        "x": -0.06853533
    },
    {
        "TS": 1710775757135,
        "x": -0.051828623
    },
    {
        "x": -0.040124733,
        "TS": 1710775757190
    },
    {
        "x": -0.033668015,
        "TS": 1710775757268
    },
    {
        "TS": 1710775757320,
        "x": -0.028592087
    },
    {
        "TS": 1710775757375,
        "x": -0.021384355
    },
    {
        "TS": 1710775757432,
        "x": -0.0080952905
    },
    {
        "x": 0.0029972978,
        "TS": 1710775757505
    },
    {
        "TS": 1710775757572,
        "x": 0.009703018
    },
    {
        "x": 0.016914546,
        "TS": 1710775757645
    },
    {
        "TS": 1710775757720,
        "x": 0.019652694
    },
    {
        "x": 0.016825467,
        "TS": 1710775757797
    },
    {
        "TS": 1710775757857,
        "x": 0.019203205
    },
    {
        "x": 0.022012394,
        "TS": 1710775757928
    },
    {
        "TS": 1710775757978,
        "x": 0.024336543
    },
    {
        "TS": 1710775758044,
        "x": 0.025675077
    },
    {
        "TS": 1710775758102,
        "x": 0.026717626
    },
    {
        "x": 0.027915888,
        "TS": 1710775758156
    },
    {
        "x": 0.025753265,
        "TS": 1710775758224
    },
    {
        "TS": 1710775758285,
        "x": 0.035790496
    },
    {
        "x": 0.040324755,
        "TS": 1710775758348
    },
    {
        "x": 0.041113354,
        "TS": 1710775758398
    },
    {
        "TS": 1710775758464,
        "x": 0.04423644
    },
    {
        "x": 0.05230837,
        "TS": 1710775758513
    },
    {
        "TS": 1710775758566,
        "x": 0.053046178
    },
    {
        "TS": 1710775758638,
        "x": 0.054679167
    },
    {
        "TS": 1710775758778,
        "x": 0.06318933
    },
    {
        "TS": 1710775758851,
        "x": 0.06690328
    },
    {
        "TS": 1710775758987,
        "x": 0.06724841
    },
    {
        "TS": 1710775759081,
        "x": -0.018779103
    },
    {
        "TS": 1710775759136,
        "x": -0.07231246
    },
    {
        "x": -0.09724622,
        "TS": 1710775759271
    },
    {
        "TS": 1710775759387,
        "x": -0.12697907
    },
    {
        "TS": 1710775759456,
        "x": -0.13318703
    },
    {
        "TS": 1710775759613,
        "x": -0.13579625
    },
    {
        "x": -0.13138501,
        "TS": 1710775759670
    },
    {
        "TS": 1710775759739,
        "x": -0.11510719
    },
    {
        "TS": 1710775759801,
        "x": -0.0910008
    },
    {
        "x": -0.07891171,
        "TS": 1710775759854
    },
    {
        "TS": 1710775760005,
        "x": -0.07129
    },
    {
        "TS": 1710775760152,
        "x": -0.06600095
    },
    {
        "TS": 1710775760271,
        "x": -0.05033361
    },
    {
        "x": -0.025333673,
        "TS": 1710775760332
    },
    {
        "TS": 1710775760395,
        "x": -0.009409148
    },
    {
        "x": -0.0016537383,
        "TS": 1710775760468
    },
    {
        "TS": 1710775760555,
        "x": -0.0014747493
    },
    {
        "x": 0.0005006343,
        "TS": 1710775760628
    },
    {
        "x": 0.010758378,
        "TS": 1710775760684
    },
    {
        "x": 0.016356204,
        "TS": 1710775760787
    },
    {
        "TS": 1710775760860,
        "x": 0.021232627
    },
    {
        "x": 0.019299626,
        "TS": 1710775760928
    },
    {
        "TS": 1710775760993,
        "x": 0.029874235
    },
    {
        "TS": 1710775761051,
        "x": 0.036684543
    },
    {
        "x": 0.039074756,
        "TS": 1710775761129
    },
    {
        "TS": 1710775761194,
        "x": 0.04276529
    },
    {
        "x": 0.04937682,
        "TS": 1710775761273
    },
    {
        "TS": 1710775761353,
        "x": 0.058029704
    },
    {
        "x": 0.060874578,
        "TS": 1710775761418
    },
    {
        "x": 0.05915337,
        "TS": 1710775761475
    },
    {
        "x": 0.051995255,
        "TS": 1710775761527
    },
    {
        "TS": 1710775761587,
        "x": 0.049314387
    },
    {
        "x": 0.045633517,
        "TS": 1710775761646
    },
    {
        "TS": 1710775761701,
        "x": 0.039550506
    },
    {
        "TS": 1710775761765,
        "x": 0.034079857
    },
    {
        "x": 0.038409323,
        "TS": 1710775761829
    },
    {
        "TS": 1710775761889,
        "x": 0.035540827
    },
    {
        "x": -0.045086633,
        "TS": 1710775761948
    },
    {
        "x": -0.09872108,
        "TS": 1710775762020
    },
    {
        "x": -0.12057005,
        "TS": 1710775762079
    },
    {
        "x": -0.13572243,
        "TS": 1710775762131
    },
    {
        "TS": 1710775762189,
        "x": -0.14570718
    },
    {
        "TS": 1710775762246,
        "x": -0.14588699
    },
    {
        "TS": 1710775762302,
        "x": -0.1421601
    },
    {
        "TS": 1710775762354,
        "x": -0.13382216
    },
    {
        "TS": 1710775762415,
        "x": -0.12531665
    },
    {
        "TS": 1710775762479,
        "x": -0.108840056
    },
    {
        "TS": 1710775762558,
        "x": -0.09179929
    },
    {
        "TS": 1710775762609,
        "x": -0.08563304
    },
    {
        "TS": 1710775762657,
        "x": -0.08050256
    },
    {
        "TS": 1710775762729,
        "x": -0.07004619
    },
    {
        "TS": 1710775762783,
        "x": -0.053527087
    },
    {
        "x": -0.024583705,
        "TS": 1710775762881
    },
    {
        "x": -0.011599451,
        "TS": 1710775762943
    },
    {
        "TS": 1710775762993,
        "x": 0.017205365
    },
    {
        "TS": 1710775763063,
        "x": 0.025289819
    },
    {
        "TS": 1710775763113,
        "x": 0.02896528
    },
    {
        "x": 0.03830285,
        "TS": 1710775763194
    },
    {
        "TS": 1710775763262,
        "x": 0.037634853
    },
    {
        "TS": 1710775763330,
        "x": 0.03462385
    },
    {
        "TS": 1710775763397,
        "x": 0.035171237
    },
    {
        "TS": 1710775763451,
        "x": 0.037380617
    },
    {
        "TS": 1710775763527,
        "x": 0.025012095
    },
    {
        "TS": 1710775763583,
        "x": 0.020057334
    },
    {
        "x": 0.015885463,
        "TS": 1710775763638
    },
    {
        "TS": 1710775763697,
        "x": 0.025858734
    },
    {
        "x": 0.04298877,
        "TS": 1710775763769
    },
    {
        "x": 0.05134977,
        "TS": 1710775763817
    },
    {
        "x": 0.05272207,
        "TS": 1710775763865
    },
    {
        "x": 0.0465629,
        "TS": 1710775763919
    },
    {
        "TS": 1710775763979,
        "x": 0.036895894
    },
    {
        "x": 0.040096346,
        "TS": 1710775764028
    },
    {
        "TS": 1710775764075,
        "x": 0.039387822
    },
    {
        "TS": 1710775764124,
        "x": 0.04175424
    },
    {
        "x": 0.04484333,
        "TS": 1710775764176
    },
    {
        "TS": 1710775764238,
        "x": 0.06285958
    },
    {
        "TS": 1710775764292,
        "x": 0.06379316
    },
    {
        "TS": 1710775764344,
        "x": 0.06509711
    },
    {
        "TS": 1710775764395,
        "x": 0.061451655
    },
    {
        "TS": 1710775764448,
        "x": 0.056555558
    },
    {
        "x": 0.053720713,
        "TS": 1710775764497
    },
    {
        "TS": 1710775764549,
        "x": 0.04411857
    },
    {
        "x": 0.03749471,
        "TS": 1710775764602
    },
    {
        "x": 0.022645421,
        "TS": 1710775764650
    },
    {
        "TS": 1710775764698,
        "x": -0.06425842
    },
    {
        "x": -0.12724137,
        "TS": 1710775764743
    },
    {
        "x": -0.14770946,
        "TS": 1710775764789
    },
    {
        "TS": 1710775764835,
        "x": -0.15435988
    },
    {
        "TS": 1710775764882,
        "x": -0.15902592
    },
    {
        "x": -0.15540676,
        "TS": 1710775764929
    },
    {
        "x": -0.1508897,
        "TS": 1710775764981
    },
    {
        "TS": 1710775765036,
        "x": -0.15054253
    },
    {
        "TS": 1710775765088,
        "x": -0.1438815
    },
    {
        "TS": 1710775765132,
        "x": -0.14219716
    },
    {
        "TS": 1710775765180,
        "x": -0.14057669
    },
    {
        "x": -0.13491732,
        "TS": 1710775765229
    },
    {
        "TS": 1710775765278,
        "x": -0.12113449
    },
    {
        "x": -0.10454034,
        "TS": 1710775765330
    },
    {
        "x": -0.09658847,
        "TS": 1710775765381
    },
    {
        "x": -0.097883105,
        "TS": 1710775765434
    },
    {
        "x": -0.09874049,
        "TS": 1710775765491
    },
    {
        "TS": 1710775765549,
        "x": -0.09231514
    },
    {
        "TS": 1710775765605,
        "x": -0.079045184
    },
    {
        "x": -0.0680276,
        "TS": 1710775765656
    },
    {
        "x": -0.041124243,
        "TS": 1710775765706
    },
    {
        "x": -0.025132678,
        "TS": 1710775765753
    },
    {
        "TS": 1710775765804,
        "x": -0.01814191
    },
    {
        "TS": 1710775765850,
        "x": -0.015477087
    },
    {
        "x": -0.0153661035,
        "TS": 1710775765910
    },
    {
        "TS": 1710775765958,
        "x": -0.0067943186
    },
    {
        "TS": 1710775766008,
        "x": -0.0045740344
    },
    {
        "TS": 1710775766062,
        "x": -0.003973786
    },
    {
        "x": 0.005921811,
        "TS": 1710775766116
    },
    {
        "x": 0.014636666,
        "TS": 1710775766167
    },
    {
        "x": 0.019065306,
        "TS": 1710775766219
    },
    {
        "x": 0.020717323,
        "TS": 1710775766275
    },
    {
        "TS": 1710775766350,
        "x": 0.018624365
    },
    {
        "TS": 1710775766453,
        "x": 0.015507743
    },
    {
        "TS": 1710775766565,
        "x": 0.013430059
    },
    {
        "x": 0.02905313,
        "TS": 1710775766623
    },
    {
        "TS": 1710775766680,
        "x": 0.042678256
    },
    {
        "x": 0.046483345,
        "TS": 1710775766733
    },
    {
        "TS": 1710775766804,
        "x": 0.043233126
    },
    {
        "x": 0.04031865,
        "TS": 1710775766867
    },
    {
        "TS": 1710775766963,
        "x": 0.035802953
    },
    {
        "x": 0.038266804,
        "TS": 1710775767009
    },
    {
        "TS": 1710775767060,
        "x": 0.039278828
    },
    {
        "TS": 1710775767138,
        "x": 0.038340528
    },
    {
        "TS": 1710775767222,
        "x": 0.036132034
    },
    {
        "TS": 1710775767282,
        "x": 0.038854342
    },
    {
        "x": 0.039674502,
        "TS": 1710775767351
    },
    {
        "x": -0.042689472,
        "TS": 1710775767409
    },
    {
        "TS": 1710775767491,
        "x": -0.08959335
    },
    {
        "TS": 1710775767548,
        "x": -0.109753765
    },
    {
        "TS": 1710775767596,
        "x": -0.12449185
    },
    {
        "TS": 1710775767647,
        "x": -0.14164543
    },
    {
        "TS": 1710775767698,
        "x": -0.14812249
    },
    {
        "TS": 1710775767750,
        "x": -0.14260118
    },
    {
        "TS": 1710775767796,
        "x": -0.13394378
    },
    {
        "TS": 1710775767849,
        "x": -0.12289586
    },
    {
        "x": -0.1025809,
        "TS": 1710775767894
    },
    {
        "x": -0.08904417,
        "TS": 1710775767942
    },
    {
        "x": -0.047910437,
        "TS": 1710775767989
    },
    {
        "x": -0.03310802,
        "TS": 1710775768036
    },
    {
        "x": -0.025108892,
        "TS": 1710775768082
    },
    {
        "x": -0.020231757,
        "TS": 1710775768128
    },
    {
        "x": -0.016185105,
        "TS": 1710775768174
    },
    {
        "x": -0.009850357,
        "TS": 1710775768219
    },
    {
        "TS": 1710775768264,
        "x": -0.010780327
    },
    {
        "TS": 1710775768315,
        "x": -0.010032743
    },
    {
        "x": -0.0067791604,
        "TS": 1710775768360
    },
    {
        "TS": 1710775768406,
        "x": -0.0016014613
    },
    {
        "x": -0.0017260388,
        "TS": 1710775768459
    },
    {
        "TS": 1710775768547,
        "x": -0.0026104152
    },
    {
        "x": 0.006184384,
        "TS": 1710775768669
    },
    {
        "x": 0.0145883,
        "TS": 1710775768794
    },
    {
        "x": 0.023815587,
        "TS": 1710775768892
    },
    {
        "x": 0.028377559,
        "TS": 1710775768941
    },
    {
        "x": 0.029280625,
        "TS": 1710775769001
    },
    {
        "TS": 1710775769130,
        "x": 0.03348508
    },
    {
        "x": 0.027339742,
        "TS": 1710775769236
    },
    {
        "TS": 1710775769295,
        "x": 0.02313196
    },
    {
        "TS": 1710775769372,
        "x": 0.017916303
    },
    {
        "x": 0.028228004,
        "TS": 1710775769427
    },
    {
        "TS": 1710775769488,
        "x": 0.041292198
    },
    {
        "TS": 1710775769563,
        "x": 0.04721103
    },
    {
        "x": 0.05313063,
        "TS": 1710775769609
    },
    {
        "x": 0.05506233,
        "TS": 1710775769670
    },
    {
        "TS": 1710775769727,
        "x": 0.048419535
    },
    {
        "TS": 1710775769773,
        "x": 0.041709967
    },
    {
        "x": 0.040209346,
        "TS": 1710775769826
    },
    {
        "x": 0.037060145,
        "TS": 1710775769877
    },
    {
        "x": 0.039183415,
        "TS": 1710775769927
    },
    {
        "x": 0.04160723,
        "TS": 1710775770023
    },
    {
        "x": 0.03986421,
        "TS": 1710775770160
    },
    {
        "x": 0.01905629,
        "TS": 1710775770232
    },
    {
        "x": -0.04029606,
        "TS": 1710775770282
    },
    {
        "TS": 1710775770345,
        "x": -0.07683347
    },
    {
        "TS": 1710775770408,
        "x": -0.096378386
    },
    {
        "x": -0.10745513,
        "TS": 1710775770475
    },
    {
        "TS": 1710775770525,
        "x": -0.1146847
    },
    {
        "TS": 1710775770570,
        "x": -0.11878173
    },
    {
        "x": -0.12241937,
        "TS": 1710775770621
    },
    {
        "x": -0.08971319,
        "TS": 1710775770673
    },
    {
        "x": -0.06835578,
        "TS": 1710775770728
    },
    {
        "TS": 1710775770790,
        "x": -0.05630718
    },
    {
        "TS": 1710775770843,
        "x": -0.039143927
    },
    {
        "TS": 1710775770892,
        "x": -0.026438167
    },
    {
        "TS": 1710775770950,
        "x": -0.014934849
    },
    {
        "x": -0.010656759,
        "TS": 1710775771028
    },
    {
        "x": -0.007394552,
        "TS": 1710775771086
    },
    {
        "x": -0.001740031,
        "TS": 1710775771143
    },
    {
        "TS": 1710775771232,
        "x": -0.0059100576
    },
    {
        "TS": 1710775771302,
        "x": -0.013850674
    },
    {
        "TS": 1710775771382,
        "x": -0.01627051
    },
    {
        "TS": 1710775771461,
        "x": -0.011777595
    },
    {
        "TS": 1710775771517,
        "x": -0.01507296
    },
    {
        "x": -0.002354037,
        "TS": 1710775771633
    },
    {
        "TS": 1710775771716,
        "x": 0.0074902773
    },
    {
        "x": 0.0065259114,
        "TS": 1710775771836
    },
    {
        "TS": 1710775771887,
        "x": 0.008185983
    },
    {
        "x": 0.0067048706,
        "TS": 1710775771936
    },
    {
        "x": 0.0045628995,
        "TS": 1710775771987
    },
    {
        "TS": 1710775772042,
        "x": 0.0033640973
    },
    {
        "x": 0.0019281395,
        "TS": 1710775772087
    },
    {
        "x": 0.009267457,
        "TS": 1710775772136
    },
    {
        "x": 0.014999505,
        "TS": 1710775772185
    },
    {
        "x": 0.01697899,
        "TS": 1710775772229
    },
    {
        "x": 0.020379402,
        "TS": 1710775772286
    },
    {
        "TS": 1710775772348,
        "x": 0.017554916
    },
    {
        "TS": 1710775772400,
        "x": 0.010943785
    },
    {
        "TS": 1710775772481,
        "x": 0.010363255
    },
    {
        "TS": 1710775772558,
        "x": 0.007917494
    },
    {
        "TS": 1710775772612,
        "x": 0.010868076
    },
    {
        "x": 0.022432305,
        "TS": 1710775772675
    },
    {
        "TS": 1710775772747,
        "x": 0.033505898
    },
    {
        "TS": 1710775772819,
        "x": 0.040925782
    },
    {
        "TS": 1710775772901,
        "x": 0.040881168
    },
    {
        "x": 0.039790105,
        "TS": 1710775772962
    },
    {
        "x": 0.037504338,
        "TS": 1710775773016
    },
    {
        "x": 0.031918462,
        "TS": 1710775773097
    },
    {
        "TS": 1710775773160,
        "x": 0.026191514
    },
    {
        "TS": 1710775773264,
        "x": 0.018353343
    },
    {
        "TS": 1710775773354,
        "x": 0.020952169
    },
    {
        "TS": 1710775773417,
        "x": 0.023860272
    },
    {
        "TS": 1710775773505,
        "x": 0.026626755
    },
    {
        "x": 0.028741151,
        "TS": 1710775773709
    },
    {
        "TS": 1710775773767,
        "x": -0.045662865
    },
    {
        "TS": 1710775773830,
        "x": -0.077537864
    },
    {
        "x": -0.092963375,
        "TS": 1710775773918
    },
    {
        "TS": 1710775773979,
        "x": -0.09836718
    },
    {
        "x": -0.09659276,
        "TS": 1710775774033
    },
    {
        "x": -0.08888483,
        "TS": 1710775774086
    },
    {
        "x": -0.08338269,
        "TS": 1710775774149
    },
    {
        "x": -0.07118288,
        "TS": 1710775774204
    },
    {
        "x": -0.06198693,
        "TS": 1710775774317
    },
    {
        "TS": 1710775774385,
        "x": -0.051112983
    },
    {
        "TS": 1710775774460,
        "x": -0.04244337
    },
    {
        "x": -0.03779754,
        "TS": 1710775774563
    },
    {
        "x": -0.03130996,
        "TS": 1710775774626
    },
    {
        "x": -0.025599685,
        "TS": 1710775774720
    },
    {
        "TS": 1710775774802,
        "x": -0.009777401
    },
    {
        "x": -0.0027272552,
        "TS": 1710775774963
    },
    {
        "TS": 1710775775017,
        "x": 0.0060497485
    },
    {
        "x": 0.011751108,
        "TS": 1710775775073
    },
    {
        "x": 0.015431993,
        "TS": 1710775775176
    },
    {
        "x": 0.019798677,
        "TS": 1710775775308
    },
    {
        "x": 0.049874738,
        "TS": 1710775775439
    },
    {
        "TS": 1710775775532,
        "x": 0.06947008
    },
    {
        "TS": 1710775775599,
        "x": 0.07899436
    },
    {
        "x": 0.08269646,
        "TS": 1710775775669
    },
    {
        "TS": 1710775775731,
        "x": 0.08942805
    },
    {
        "TS": 1710775775778,
        "x": 0.085696824
    },
    {
        "x": 0.08084135,
        "TS": 1710775775836
    },
    {
        "x": 0.07679051,
        "TS": 1710775775889
    },
    {
        "TS": 1710775775996,
        "x": 0.06673553
    },
    {
        "TS": 1710775776072,
        "x": 0.062389076
    },
    {
        "TS": 1710775776169,
        "x": 0.060461286
    },
    {
        "x": -0.019305106,
        "TS": 1710775776224
    },
    {
        "x": -0.077312365,
        "TS": 1710775776283
    },
    {
        "TS": 1710775776349,
        "x": -0.103346735
    },
    {
        "TS": 1710775776422,
        "x": -0.11610988
    },
    {
        "TS": 1710775776475,
        "x": -0.117693186
    },
    {
        "x": -0.1132844,
        "TS": 1710775776538
    },
    {
        "TS": 1710775776595,
        "x": -0.0945343
    },
    {
        "TS": 1710775776663,
        "x": -0.08123347
    },
    {
        "TS": 1710775776720,
        "x": -0.06683626
    },
    {
        "x": -0.061337337,
        "TS": 1710775776779
    },
    {
        "TS": 1710775776846,
        "x": -0.05631308
    },
    {
        "x": -0.05656019,
        "TS": 1710775776904
    },
    {
        "x": -0.053192005,
        "TS": 1710775776966
    },
    {
        "TS": 1710775777029,
        "x": -0.039709084
    },
    {
        "TS": 1710775777108,
        "x": -0.02790032
    },
    {
        "TS": 1710775777199,
        "x": -0.01843781
    },
    {
        "x": -0.016130213,
        "TS": 1710775777279
    },
    {
        "x": -0.02258671,
        "TS": 1710775777362
    },
    {
        "TS": 1710775777441,
        "x": -0.019306589
    },
    {
        "x": -0.015860252,
        "TS": 1710775777495
    },
    {
        "TS": 1710775777550,
        "x": -0.010829464
    },
    {
        "TS": 1710775777609,
        "x": -0.010278594
    },
    {
        "TS": 1710775777687,
        "x": -0.006367378
    },
    {
        "TS": 1710775777763,
        "x": -0.004878156
    },
    {
        "TS": 1710775777822,
        "x": -0.0069944337
    },
    {
        "x": -0.008793931,
        "TS": 1710775777878
    },
    {
        "x": 0.0011417307,
        "TS": 1710775777972
    },
    {
        "x": 0.011574157,
        "TS": 1710775778034
    },
    {
        "x": 0.01503836,
        "TS": 1710775778094
    },
    {
        "TS": 1710775778148,
        "x": 0.00978763
    },
    {
        "TS": 1710775778224,
        "x": 0.0054396465
    },
    {
        "TS": 1710775778296,
        "x": -0.0013258532
    },
    {
        "x": -0.005191803,
        "TS": 1710775778348
    },
    {
        "x": -0.0011328906,
        "TS": 1710775778421
    },
    {
        "TS": 1710775778487,
        "x": 0.00529192
    },
    {
        "x": 0.009535711,
        "TS": 1710775778547
    },
    {
        "x": 0.021567449,
        "TS": 1710775778625
    },
    {
        "x": 0.02872356,
        "TS": 1710775778689
    },
    {
        "TS": 1710775778752,
        "x": 0.03034586
    },
    {
        "TS": 1710775778835,
        "x": 0.03175947
    },
    {
        "x": 0.041809537,
        "TS": 1710775778893
    },
    {
        "TS": 1710775778961,
        "x": 0.047681615
    },
    {
        "x": 0.048003264,
        "TS": 1710775779017
    },
    {
        "x": 0.049059898,
        "TS": 1710775779074
    },
    {
        "x": 0.0057863817,
        "TS": 1710775779123
    },
    {
        "TS": 1710775779181,
        "x": -0.045485526
    },
    {
        "TS": 1710775779233,
        "x": -0.06755597
    },
    {
        "x": -0.079027444,
        "TS": 1710775779299
    },
    {
        "x": -0.09151189,
        "TS": 1710775779351
    },
    {
        "TS": 1710775779402,
        "x": -0.095551185
    },
    {
        "TS": 1710775779477,
        "x": -0.09453092
    },
    {
        "x": -0.09289627,
        "TS": 1710775779539
    },
    {
        "x": -0.09232847,
        "TS": 1710775779589
    },
    {
        "TS": 1710775779656,
        "x": -0.095622905
    },
    {
        "TS": 1710775779715,
        "x": -0.08456987
    },
    {
        "TS": 1710775779767,
        "x": -0.07608069
    },
    {
        "TS": 1710775779829,
        "x": -0.08197647
    },
    {
        "TS": 1710775779907,
        "x": -0.06119676
    },
    {
        "TS": 1710775779981,
        "x": -0.048051436
    },
    {
        "x": -0.059409246,
        "TS": 1710775780046
    },
    {
        "TS": 1710775780112,
        "x": -0.061773427
    },
    {
        "x": -0.0607435,
        "TS": 1710775780170
    },
    {
        "TS": 1710775780235,
        "x": -0.0515458
    },
    {
        "x": -0.04399082,
        "TS": 1710775780300
    },
    {
        "TS": 1710775780363,
        "x": -0.041664172
    },
    {
        "x": -0.03843471,
        "TS": 1710775780424
    },
    {
        "TS": 1710775780497,
        "x": -0.03998933
    },
    {
        "x": -0.037658527,
        "TS": 1710775780558
    },
    {
        "TS": 1710775780611,
        "x": -0.03251753
    },
    {
        "x": -0.02237589,
        "TS": 1710775780665
    },
    {
        "x": -0.017742984,
        "TS": 1710775780724
    },
    {
        "x": -0.017485298,
        "TS": 1710775780786
    },
    {
        "x": -0.011101298,
        "TS": 1710775780834
    },
    {
        "TS": 1710775780891,
        "x": -0.008475393
    },
    {
        "TS": 1710775780967,
        "x": -0.008164495
    },
    {
        "TS": 1710775781024,
        "x": -0.002283983
    },
    {
        "TS": 1710775781081,
        "x": 0.0030671395
    },
    {
        "x": 0.0012070164,
        "TS": 1710775781132
    },
    {
        "x": 0.024220563,
        "TS": 1710775781178
    },
    {
        "x": 0.033032626,
        "TS": 1710775781227
    },
    {
        "TS": 1710775781281,
        "x": 0.034017503
    },
    {
        "x": 0.03228362,
        "TS": 1710775781333
    },
    {
        "TS": 1710775781394,
        "x": 0.029532991
    },
    {
        "x": 0.031785395,
        "TS": 1710775781440
    },
    {
        "x": 0.031121485,
        "TS": 1710775781490
    },
    {
        "x": 0.03336427,
        "TS": 1710775781537
    },
    {
        "TS": 1710775781598,
        "x": 0.030674344
    },
    {
        "x": 0.024265034,
        "TS": 1710775781668
    },
    {
        "x": 0.021154188,
        "TS": 1710775781716
    },
    {
        "TS": 1710775781774,
        "x": 0.027945373
    },
    {
        "TS": 1710775781829,
        "x": 0.029096536
    },
    {
        "TS": 1710775781888,
        "x": 0.030999359
    },
    {
        "TS": 1710775781944,
        "x": 0.03241563
    },
    {
        "x": 0.03980006,
        "TS": 1710775782002
    },
    {
        "x": 0.047817726,
        "TS": 1710775782054
    },
    {
        "TS": 1710775782133,
        "x": 0.05926968
    },
    {
        "TS": 1710775782190,
        "x": 0.06192869
    },
    {
        "TS": 1710775782244,
        "x": 0.0539887
    },
    {
        "x": 0.040175617,
        "TS": 1710775782299
    },
    {
        "TS": 1710775782373,
        "x": -0.032089695
    },
    {
        "x": -0.06690714,
        "TS": 1710775782468
    },
    {
        "TS": 1710775782541,
        "x": -0.07943825
    },
    {
        "TS": 1710775782620,
        "x": -0.080494665
    },
    {
        "TS": 1710775782681,
        "x": -0.077550724
    },
    {
        "x": -0.07377849,
        "TS": 1710775782735
    },
    {
        "TS": 1710775782790,
        "x": -0.062562376
    },
    {
        "TS": 1710775782844,
        "x": -0.05600529
    },
    {
        "x": -0.049263567,
        "TS": 1710775782893
    },
    {
        "TS": 1710775782942,
        "x": -0.049495794
    },
    {
        "x": -0.037783273,
        "TS": 1710775783004
    },
    {
        "x": -0.02615933,
        "TS": 1710775783076
    },
    {
        "TS": 1710775783135,
        "x": -0.020375289
    },
    {
        "TS": 1710775783191,
        "x": -0.01347718
    },
    {
        "x": -0.025947891,
        "TS": 1710775783243
    },
    {
        "TS": 1710775783320,
        "x": -0.022238009
    },
    {
        "x": -0.014219083,
        "TS": 1710775783406
    },
    {
        "TS": 1710775783512,
        "x": -0.007905208
    },
    {
        "x": -0.0068936124,
        "TS": 1710775783629
    },
    {
        "x": -0.012434535,
        "TS": 1710775783755
    },
    {
        "x": 0.007340491,
        "TS": 1710775783870
    },
    {
        "x": 0.033114426,
        "TS": 1710775783927
    },
    {
        "x": 0.038966857,
        "TS": 1710775783993
    },
    {
        "x": 0.0471422,
        "TS": 1710775784055
    },
    {
        "x": 0.028929614,
        "TS": 1710775784105
    },
    {
        "TS": 1710775784178,
        "x": 0.019824564
    },
    {
        "TS": 1710775784247,
        "x": 0.021369256
    },
    {
        "x": 0.036944635,
        "TS": 1710775784298
    },
    {
        "x": 0.051027708,
        "TS": 1710775784352
    },
    {
        "x": 0.057588913,
        "TS": 1710775784399
    },
    {
        "TS": 1710775784448,
        "x": 0.06041996
    },
    {
        "TS": 1710775784515,
        "x": 0.060011618
    },
    {
        "x": 0.060121533,
        "TS": 1710775784595
    },
    {
        "TS": 1710775784654,
        "x": 0.061192885
    },
    {
        "TS": 1710775784706,
        "x": 0.058660444
    },
    {
        "TS": 1710775784762,
        "x": 0.056747355
    },
    {
        "x": 0.05911372,
        "TS": 1710775784824
    },
    {
        "TS": 1710775784879,
        "x": 0.06574397
    },
    {
        "x": 0.06716559,
        "TS": 1710775784952
    },
    {
        "TS": 1710775785001,
        "x": 0.06245916
    },
    {
        "x": 0.06529643,
        "TS": 1710775785059
    },
    {
        "TS": 1710775785112,
        "x": -0.017839774
    },
    {
        "TS": 1710775785165,
        "x": -0.050062332
    },
    {
        "TS": 1710775785212,
        "x": -0.07373948
    },
    {
        "TS": 1710775785276,
        "x": -0.08274698
    },
    {
        "x": -0.08790159,
        "TS": 1710775785324
    },
    {
        "TS": 1710775785377,
        "x": -0.08943879
    },
    {
        "x": -0.09290747,
        "TS": 1710775785467
    },
    {
        "x": -0.08867319,
        "TS": 1710775785547
    },
    {
        "x": -0.072566554,
        "TS": 1710775785626
    },
    {
        "TS": 1710775785682,
        "x": -0.062480975
    },
    {
        "TS": 1710775785780,
        "x": -0.056661636
    },
    {
        "TS": 1710775785846,
        "x": -0.051073376
    },
    {
        "TS": 1710775785901,
        "x": -0.048089735
    },
    {
        "TS": 1710775785979,
        "x": -0.037799284
    },
    {
        "TS": 1710775786087,
        "x": -0.037514344
    },
    {
        "TS": 1710775786186,
        "x": -0.010138128
    },
    {
        "x": 0.0052540954,
        "TS": 1710775786246
    },
    {
        "TS": 1710775786308,
        "x": 0.017450249
    },
    {
        "x": 0.003656555,
        "TS": 1710775786387
    },
    {
        "TS": 1710775786466,
        "x": 0.0074503664
    },
    {
        "TS": 1710775786529,
        "x": 0.006238632
    },
    {
        "x": 0.011792671,
        "TS": 1710775786584
    },
    {
        "x": -0.0034264065,
        "TS": 1710775786675
    },
    {
        "TS": 1710775786724,
        "x": 0.004093565
    },
    {
        "x": 0.0075528286,
        "TS": 1710775786782
    },
    {
        "TS": 1710775786836,
        "x": 0.032162704
    },
    {
        "TS": 1710775786885,
        "x": 0.027795877
    },
    {
        "TS": 1710775786954,
        "x": 0.034475446
    },
    {
        "TS": 1710775787012,
        "x": 0.04135777
    },
    {
        "TS": 1710775787066,
        "x": 0.056692358
    },
    {
        "x": 0.07124501,
        "TS": 1710775787120
    },
    {
        "x": 0.08033396,
        "TS": 1710775787172
    },
    {
        "TS": 1710775787220,
        "x": 0.08651526
    },
    {
        "x": 0.0886406,
        "TS": 1710775787269
    },
    {
        "x": 0.09345959,
        "TS": 1710775787317
    },
    {
        "TS": 1710775787376,
        "x": 0.0759873
    },
    {
        "TS": 1710775787425,
        "x": 0.06583954
    },
    {
        "TS": 1710775787481,
        "x": 0.05890356
    },
    {
        "TS": 1710775787534,
        "x": 0.05997228
    },
    {
        "x": 0.06397018,
        "TS": 1710775787579
    },
    {
        "x": 0.06167104,
        "TS": 1710775787635
    },
    {
        "x": 0.06753315,
        "TS": 1710775787682
    },
    {
        "TS": 1710775787733,
        "x": 0.06955896
    },
    {
        "TS": 1710775787800,
        "x": 0.058738947
    },
    {
        "x": -0.010429114,
        "TS": 1710775787851
    },
    {
        "TS": 1710775787900,
        "x": -0.049370214
    },
    {
        "TS": 1710775787946,
        "x": -0.06013385
    },
    {
        "x": -0.068976805,
        "TS": 1710775787993
    },
    {
        "TS": 1710775788041,
        "x": -0.07396914
    },
    {
        "x": -0.07602071,
        "TS": 1710775788092
    },
    {
        "TS": 1710775788141,
        "x": -0.0788708
    },
    {
        "x": -0.08456868,
        "TS": 1710775788214
    },
    {
        "x": -0.06955068,
        "TS": 1710775788269
    },
    {
        "x": -0.07398831,
        "TS": 1710775788322
    },
    {
        "TS": 1710775788379,
        "x": -0.06857189
    },
    {
        "x": -0.05471165,
        "TS": 1710775788437
    },
    {
        "TS": 1710775788492,
        "x": -0.042058647
    },
    {
        "x": -0.036061764,
        "TS": 1710775788544
    },
    {
        "x": -0.036554627,
        "TS": 1710775788599
    },
    {
        "TS": 1710775788664,
        "x": -0.034685653
    },
    {
        "TS": 1710775788717,
        "x": -0.021595862
    },
    {
        "x": -0.017909281,
        "TS": 1710775788766
    },
    {
        "TS": 1710775788816,
        "x": -0.020115504
    },
    {
        "x": -0.018128354,
        "TS": 1710775788866
    },
    {
        "TS": 1710775788915,
        "x": -0.026038699
    },
    {
        "x": -0.03470664,
        "TS": 1710775788966
    },
    {
        "x": -0.03474759,
        "TS": 1710775789015
    },
    {
        "TS": 1710775789071,
        "x": -0.035279386
    },
    {
        "x": -0.028966311,
        "TS": 1710775789124
    },
    {
        "x": -0.026829839,
        "TS": 1710775789175
    },
    {
        "x": -0.01925819,
        "TS": 1710775789227
    },
    {
        "x": -0.0120383985,
        "TS": 1710775789286
    },
    {
        "TS": 1710775789343,
        "x": -0.0052456893
    },
    {
        "TS": 1710775789390,
        "x": 0.005902946
    },
    {
        "TS": 1710775789443,
        "x": 0.010558363
    },
    {
        "TS": 1710775789509,
        "x": 0.008038048
    },
    {
        "TS": 1710775789558,
        "x": 0.005058773
    },
    {
        "x": 0.004200246,
        "TS": 1710775789612
    },
    {
        "x": 0.015297577,
        "TS": 1710775789671
    },
    {
        "x": 0.021801483,
        "TS": 1710775789729
    },
    {
        "x": 0.028199874,
        "TS": 1710775789782
    },
    {
        "TS": 1710775789840,
        "x": 0.03695371
    },
    {
        "x": 0.047624394,
        "TS": 1710775789895
    },
    {
        "x": 0.05348269,
        "TS": 1710775789955
    },
    {
        "TS": 1710775790012,
        "x": 0.051763326
    },
    {
        "x": 0.052345507,
        "TS": 1710775790064
    },
    {
        "TS": 1710775790112,
        "x": 0.032673843
    },
    {
        "TS": 1710775790159,
        "x": 0.02950152
    },
    {
        "TS": 1710775790207,
        "x": 0.02516855
    },
    {
        "x": 0.038068943,
        "TS": 1710775790257
    },
    {
        "x": 0.04411574,
        "TS": 1710775790307
    },
    {
        "TS": 1710775790364,
        "x": 0.04897485
    },
    {
        "TS": 1710775790411,
        "x": 0.05533186
    },
    {
        "x": 0.055367157,
        "TS": 1710775790456
    },
    {
        "x": 0.06008665,
        "TS": 1710775790503
    },
    {
        "x": 0.05424148,
        "TS": 1710775790550
    },
    {
        "x": 0.05041355,
        "TS": 1710775790596
    },
    {
        "x": 0.052286662,
        "TS": 1710775790650
    },
    {
        "x": 0.052814033,
        "TS": 1710775790700
    },
    {
        "x": 0.07454911,
        "TS": 1710775790753
    },
    {
        "TS": 1710775790808,
        "x": 0.07439799
    },
    {
        "TS": 1710775790861,
        "x": 0.07155189
    },
    {
        "TS": 1710775790916,
        "x": 0.064765155
    },
    {
        "TS": 1710775790969,
        "x": 0.05671043
    },
    {
        "TS": 1710775791017,
        "x": -0.010805011
    },
    {
        "x": -0.058442045,
        "TS": 1710775791079
    },
    {
        "x": -0.07061981,
        "TS": 1710775791134
    },
    {
        "x": -0.081966214,
        "TS": 1710775791193
    },
    {
        "TS": 1710775791248,
        "x": -0.09977391
    },
    {
        "TS": 1710775791298,
        "x": -0.109424934
    },
    {
        "x": -0.11641846,
        "TS": 1710775791356
    },
    {
        "x": -0.11914654,
        "TS": 1710775791415
    },
    {
        "TS": 1710775791462,
        "x": -0.095944725
    },
    {
        "TS": 1710775791517,
        "x": -0.07054241
    },
    {
        "TS": 1710775791631,
        "x": -0.055484787
    },
    {
        "TS": 1710775791814,
        "x": -0.04630611
    },
    {
        "TS": 1710775791884,
        "x": -0.04676547
    },
    {
        "x": -0.050161622,
        "TS": 1710775791940
    },
    {
        "TS": 1710775791995,
        "x": -0.048783265
    },
    {
        "x": -0.04041261,
        "TS": 1710775792048
    },
    {
        "x": -0.03594823,
        "TS": 1710775792103
    },
    {
        "TS": 1710775792153,
        "x": -0.032711085
    },
    {
        "TS": 1710775792199,
        "x": -0.03530708
    },
    {
        "x": -0.02947829,
        "TS": 1710775792255
    },
    {
        "x": -0.027178554,
        "TS": 1710775792306
    },
    {
        "x": -0.01824782,
        "TS": 1710775792352
    },
    {
        "x": -0.010315195,
        "TS": 1710775792399
    },
    {
        "x": -0.0057701804,
        "TS": 1710775792448
    },
    {
        "TS": 1710775792504,
        "x": -0.0051657446
    },
    {
        "x": -0.006845627,
        "TS": 1710775792554
    },
    {
        "x": -0.0073213726,
        "TS": 1710775792599
    },
    {
        "x": -0.008748259,
        "TS": 1710775792654
    },
    {
        "x": -0.00525783,
        "TS": 1710775792701
    },
    {
        "x": -0.008360244,
        "TS": 1710775792754
    },
    {
        "TS": 1710775792808,
        "x": -0.0044073127
    },
    {
        "TS": 1710775792864,
        "x": -0.0067436844
    },
    {
        "x": -0.008991189,
        "TS": 1710775792926
    },
    {
        "x": -0.009036809,
        "TS": 1710775792985
    },
    {
        "x": 0.010995667,
        "TS": 1710775793033
    },
    {
        "TS": 1710775793093,
        "x": 0.02015965
    },
    {
        "x": 0.03127152,
        "TS": 1710775793140
    },
    {
        "TS": 1710775793190,
        "x": 0.029004753
    },
    {
        "x": 0.028351218,
        "TS": 1710775793269
    },
    {
        "x": 0.03799117,
        "TS": 1710775793370
    },
    {
        "TS": 1710775793422,
        "x": 0.045079518
    },
    {
        "x": 0.053369727,
        "TS": 1710775793484
    },
    {
        "x": 0.052910764,
        "TS": 1710775793536
    },
    {
        "x": 0.04475054,
        "TS": 1710775793599
    },
    {
        "x": 0.049327128,
        "TS": 1710775793653
    },
    {
        "TS": 1710775793723,
        "x": 0.06226161
    },
    {
        "TS": 1710775793789,
        "x": 0.06194216
    },
    {
        "x": 0.058701627,
        "TS": 1710775793842
    },
    {
        "x": 0.060330514,
        "TS": 1710775793890
    },
    {
        "x": 0.05770728,
        "TS": 1710775793940
    },
    {
        "TS": 1710775793990,
        "x": 0.054615743
    },
    {
        "TS": 1710775794042,
        "x": 0.05282814
    },
    {
        "x": -0.033291675,
        "TS": 1710775794095
    },
    {
        "x": -0.06967747,
        "TS": 1710775794144
    },
    {
        "x": -0.08150411,
        "TS": 1710775794202
    },
    {
        "TS": 1710775794258,
        "x": -0.0873561
    },
    {
        "x": -0.09027176,
        "TS": 1710775794318
    },
    {
        "TS": 1710775794385,
        "x": -0.0836577
    },
    {
        "x": -0.07987438,
        "TS": 1710775794471
    },
    {
        "x": -0.07097468,
        "TS": 1710775794540
    },
    {
        "TS": 1710775794594,
        "x": -0.0688671
    },
    {
        "x": -0.046658672,
        "TS": 1710775794654
    },
    {
        "x": -0.016775664,
        "TS": 1710775794718
    },
    {
        "TS": 1710775794772,
        "x": 0.011818383
    },
    {
        "x": 0.0064034685,
        "TS": 1710775794823
    },
    {
        "TS": 1710775794878,
        "x": 0.0032645203
    },
    {
        "x": -0.0024544336,
        "TS": 1710775794969
    },
    {
        "x": -0.010608319,
        "TS": 1710775795031
    },
    {
        "TS": 1710775795090,
        "x": -0.018711954
    },
    {
        "TS": 1710775795161,
        "x": -0.012479596
    },
    {
        "TS": 1710775795222,
        "x": -0.005744461
    },
    {
        "x": 0.00201511,
        "TS": 1710775795288
    },
    {
        "TS": 1710775795372,
        "x": 0.008491155
    },
    {
        "TS": 1710775795436,
        "x": 0.023343004
    },
    {
        "x": 0.033705644,
        "TS": 1710775795501
    },
    {
        "x": 0.040952012,
        "TS": 1710775795583
    },
    {
        "TS": 1710775795663,
        "x": 0.045069642
    },
    {
        "x": 0.054628383,
        "TS": 1710775795724
    },
    {
        "x": 0.056420594,
        "TS": 1710775795820
    },
    {
        "TS": 1710775795871,
        "x": 0.0685358
    },
    {
        "x": 0.07471819,
        "TS": 1710775795920
    },
    {
        "TS": 1710775796016,
        "x": 0.080632165
    },
    {
        "x": 0.08168617,
        "TS": 1710775796081
    },
    {
        "TS": 1710775796170,
        "x": 0.07359261
    },
    {
        "x": 0.06468542,
        "TS": 1710775796242
    },
    {
        "x": 0.06163879,
        "TS": 1710775796317
    },
    {
        "TS": 1710775796390,
        "x": 0.05678647
    },
    {
        "x": 0.052196592,
        "TS": 1710775796451
    },
    {
        "x": -0.034911413,
        "TS": 1710775796509
    },
    {
        "x": -0.06703034,
        "TS": 1710775796594
    },
    {
        "TS": 1710775796650,
        "x": -0.083123446
    },
    {
        "TS": 1710775796802,
        "x": -0.08859618
    },
    {
        "TS": 1710775796859,
        "x": -0.08671736
    },
    {
        "x": -0.08693815,
        "TS": 1710775796914
    },
    {
        "x": -0.07186724,
        "TS": 1710775797051
    },
    {
        "x": -0.05818232,
        "TS": 1710775797171
    },
    {
        "TS": 1710775797249,
        "x": -0.05612093
    },
    {
        "x": -0.053644076,
        "TS": 1710775797322
    },
    {
        "TS": 1710775797386,
        "x": -0.037394073
    },
    {
        "x": -0.022475999,
        "TS": 1710775797448
    },
    {
        "x": -0.012381867,
        "TS": 1710775797580
    },
    {
        "TS": 1710775797647,
        "x": -0.005206667
    },
    {
        "x": -0.0010604784,
        "TS": 1710775797795
    },
    {
        "TS": 1710775797958,
        "x": 0.01568165
    },
    {
        "TS": 1710775798043,
        "x": 0.039385457
    },
    {
        "TS": 1710775798111,
        "x": 0.048257343
    },
    {
        "x": 0.05135122,
        "TS": 1710775798171
    },
    {
        "x": 0.053929262,
        "TS": 1710775798238
    },
    {
        "TS": 1710775798295,
        "x": 0.033127658
    },
    {
        "TS": 1710775798343,
        "x": 0.047463074
    },
    {
        "x": 0.03590545,
        "TS": 1710775798394
    },
    {
        "TS": 1710775798467,
        "x": 0.0372088
    },
    {
        "TS": 1710775798522,
        "x": 0.05773135
    },
    {
        "x": 0.08125334,
        "TS": 1710775798595
    },
    {
        "x": 0.08365791,
        "TS": 1710775798642
    },
    {
        "TS": 1710775798700,
        "x": 0.087643735
    },
    {
        "TS": 1710775798752,
        "x": 0.09032554
    },
    {
        "x": 0.093335934,
        "TS": 1710775798833
    },
    {
        "x": 0.09208942,
        "TS": 1710775798901
    },
    {
        "TS": 1710775798956,
        "x": 0.093450576
    },
    {
        "x": 0.08941143,
        "TS": 1710775799012
    },
    {
        "TS": 1710775799088,
        "x": 0.09515557
    },
    {
        "TS": 1710775799142,
        "x": 0.08591312
    },
    {
        "TS": 1710775799218,
        "x": 0.087575234
    },
    {
        "TS": 1710775799271,
        "x": 0.0075976998
    },
    {
        "TS": 1710775799343,
        "x": -0.02404258
    },
    {
        "x": -0.034996755,
        "TS": 1710775799406
    },
    {
        "x": -0.037949186,
        "TS": 1710775799469
    },
    {
        "TS": 1710775799534,
        "x": -0.05208084
    },
    {
        "x": -0.045048397,
        "TS": 1710775799588
    },
    {
        "TS": 1710775799651,
        "x": -0.05537937
    },
    {
        "x": -0.042600095,
        "TS": 1710775799732
    },
    {
        "x": -0.049198553,
        "TS": 1710775799835
    },
    {
        "x": -0.04365541,
        "TS": 1710775799902
    },
    {
        "TS": 1710775799959,
        "x": -0.035663463
    },
    {
        "TS": 1710775800037,
        "x": -0.025671285
    },
    {
        "x": -0.021630682,
        "TS": 1710775800089
    },
    {
        "TS": 1710775800156,
        "x": -0.019800864
    },
    {
        "TS": 1710775800202,
        "x": -0.010783635
    },
    {
        "x": -0.011121228,
        "TS": 1710775800259
    },
    {
        "TS": 1710775800324,
        "x": -0.011797249
    },
    {
        "TS": 1710775800410,
        "x": -0.008064117
    },
    {
        "x": 0.0034820847,
        "TS": 1710775800473
    },
    {
        "x": 0.010353979,
        "TS": 1710775800527
    },
    {
        "x": 0.009933766,
        "TS": 1710775800574
    },
    {
        "TS": 1710775800627,
        "x": 0.011481643
    },
    {
        "TS": 1710775800691,
        "x": 0.018369522
    },
    {
        "TS": 1710775800740,
        "x": 0.020308081
    },
    {
        "TS": 1710775800797,
        "x": 0.020739332
    },
    {
        "x": 0.020561956,
        "TS": 1710775800869
    }
]


let testDetails = [
    {
        "words": 8,
        "_id": "64db9b745225381719427eeb",
        "orderNum": 1
    },
    {
        "_id": "64db9b745225381719427eec",
        "words": 7,
        "orderNum": 2
    },
    {
        "_id": "64db9b745225381719427eed",
        "words": 7,
        "orderNum": 3
    },
    {
        "words": 7,
        "_id": "64db9b745225381719427eee",
        "orderNum": 4
    },
    {
        "words": 6,
        "orderNum": 5,
        "_id": "64db9b745225381719427eef"
    },
    {
        "words": 7,
        "orderNum": 6,
        "_id": "64db9b745225381719427ef0"
    },
    {
        "words": 7,
        "_id": "64db9b745225381719427ef1",
        "orderNum": 7
    },
    {
        "_id": "64db9b745225381719427ef2",
        "orderNum": 8,
        "words": 7
    },
    {
        "_id": "64db9b745225381719427ef3",
        "words": 8,
        "orderNum": 9
    },
    {
        "orderNum": 10,
        "_id": "64db9b745225381719427ef4",
        "words": 7
    },
    {
        "words": 7,
        "_id": "64db9b745225381719427ef5",
        "orderNum": 11
    },
    {
        "_id": "64db9b745225381719427ef6",
        "words": 7,
        "orderNum": 12
    },
    {
        "_id": "64db9b745225381719427ef7",
        "orderNum": 13,
        "words": 8
    },
    {
        "orderNum": 14,
        "_id": "64db9b745225381719427ef8",
        "words": 6
    },
    {
        "words": 7,
        "_id": "64db9b745225381719427ef9",
        "orderNum": 15
    },
    {
        "words": 6,
        "orderNum": 16,
        "_id": "64db9b745225381719427efa"
    },
    {
        "orderNum": 17,
        "words": 4,
        "_id": "64db9b745225381719427efb"
    }
]


// calcWPM(combinedIrisPosXMove, testDetails)
